import { T } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'

interface Props {
  isCanceling: boolean
  disabled: boolean
  cancelTransfer: () => void
  isPrimary?: boolean
}
export const Cancel = ({
  isCanceling,
  disabled,
  cancelTransfer,
  isPrimary,
}: Props) => (
  <Button
    loading={isCanceling}
    disabled={disabled}
    onClick={() => {
      cancelTransfer()
    }}
    destructive={isPrimary}
    variant={isPrimary ? 'primary' : 'tertiaryNeutral'}
  >
    <T defaultMessage="Cancel transfer" id="Generics.CancelTransfer" />
  </Button>
)
